import { Injectable } from '@angular/core';

import { Store, StoreConfig } from '@datorama/akita';

import { User } from '@shared/user/models';

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'authUser'})
export class AuthUserStore extends Store<User> {
  constructor() {
    super({});
  }
}
